import { TimePicker } from "antd";
import dayjs from "dayjs";
import { useFormikContext } from "formik";
import React from "react";

interface TimeRangePickerFormikProps {
  // Formik field name to set (e.g. 'schedule.monday.timeSlots.0')
  name: string;
  minuteStep?: number;
}

export function TimeRangePickerFormik(props: TimeRangePickerFormikProps) {
  const timeFormat = "HH:mm";
  const formik = useFormikContext<any>();

  function toDayjs(
    time: { h: number; m: number } | undefined
  ): dayjs.Dayjs | undefined {
    if (!time) {
      return undefined;
    }
    return dayjs().hour(time.h).minute(time.m);
  }

  function fromDayJs(m: dayjs.Dayjs | undefined) {
    if (!m) {
      return null;
    }
    return { h: m.hour(), m: m.minute() };
  }

  const fieldValue = formik.getFieldProps(props.name).value as
    | {
        start?: { h: number; m: number } | undefined;
        end?: { h: number; m: number } | undefined;
      }
    | undefined;

  return (
    <div>
      <TimePicker.RangePicker
        value={[toDayjs(fieldValue?.start), toDayjs(fieldValue?.end)] as any}
        format={timeFormat}
        minuteStep={(props.minuteStep ?? 15) as any}
        style={{ padding: "4px 8px" }}
        onChange={(values) => {
          const start = fromDayJs(values?.[0] ?? undefined);
          const end = fromDayJs(values?.[1] ?? undefined);
          if (start && end) {
            formik.setFieldValue(props.name, { start, end });
          }
        }}
        getPopupContainer={(trigger) => trigger.parentNode as HTMLElement}
      />
    </div>
  );
}
